import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  // Still checking the token
  if (user === null) {
    return (
      <div className="min-h-screen bg-shay-cream grid place-items-center" data-testid="auth-loading">
        <div className="text-center">
          <div className="h-12 w-12 mx-auto rounded-full border-2 border-shay-gold/20 border-t-shay-gold animate-spin" />
          <p className="mt-4 text-sm uppercase tracking-widest text-shay-chocolate/60">Verifying access</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
